import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { Product } from '@/types/work/product';
import { Enterprise } from '@/store/types/public/Enterprise';
import PubHttp from '@/PubHttp';
import { PageMeta } from '@/store/types/pagination';
import { NAMESPACE as ENTERPRISE_NAMESPACE } from '@/store/models/pub/enterprises';
import { GET_ITEM, RootState } from '@/store';
import categories from '@/store/models/pub/products/categories';
import { groups } from '@/store/models/pub/products/groups';

export const NAMESPACE = 'pub/products';

export interface ProductsState extends RootState {
  items: Product[],
  item?: Product
}

export const state: ProductsState = {
  status: null,
  items: [],
  item: undefined,
  meta: undefined
};

export const getters: GetterTree<ProductsState, any> = {
  items: (state) => state.items,
  item: (state) => state.item,
  status: (state):boolean|null => state.status,
  loading: (state):boolean => state.status === null,
  meta: (state) => state.meta
};

export const actions: ActionTree<any, any> = {
  request: ({ commit, rootGetters }:any, filter:any = {}) => {
    let enterprise: Enterprise = rootGetters[ENTERPRISE_NAMESPACE + '/' + GET_ITEM];
    commit('request');
    (new PubHttp()).request({ url: `enterprises/${enterprise.id}/products`, params: filter })
      .then((resp:any) => {
        commit('success', resp.data);
      })
      .catch(() => {
        commit('error');
      });
  },
  show: ({ commit, rootGetters, rootState }:any, id:number) => {
    let enterprise: Enterprise = rootGetters[ENTERPRISE_NAMESPACE + '/' + GET_ITEM];
    commit('request');
    (new PubHttp()).request({ url: `enterprises/${enterprise.id}/products/${id}` })
      .then((resp:any) => {
        commit('successShow', resp.data.data);
      })
      .catch(() => {
        commit('error');
      });
  }
};

export const mutations: MutationTree<ProductsState> = {
  request: (state) => {
    state.status = null;
  },
  success: (state, resp:{data: Product[], meta?: PageMeta}) => {
    state.status = true;
    state.items = resp.data;
    state.meta = resp.meta;
  },
  successShow: (state, data:Product) => {
    state.item = data;
    state.status = true;
  },
  error: (state) => {
    state.status = false;
  }
};

export const products: Module<ProductsState, any> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: {
    categories: categories,
    groups: groups
  }
};
